import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Select } from 'antd';
import { format } from 'date-fns';
import { toast } from 'react-hot-toast';
import { useSelector } from 'react-redux';
import { getObservations, getAreas, addCorrectiveAction,getUsers,getMyAssignedObservations } from '../../services/observationAPI';
const WaitingPage = () => {
    const { observationId } = useParams();
    const navigate = useNavigate();
    const [observation, setObservation] = useState(null);
    const [loading, setLoading] = useState(true);
    const [users, setUsers] = useState([]);
    const [correctiveAction, setCorrectiveAction] = useState('');
    const [responsiblePerson, setResponsiblePerson] = useState('');
    const [deadline, setDeadline] = useState();
    const [dateString, setDateString] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const {user}= useSelector((state)=>state.profile)

    useEffect(() => {
        const fetchData = async () => {
            try {
                if (user.accountType === "Admin"){
                                    const observationsData = await getObservations();
                                
                
                                  // Make sure this function exists
                                const foundObservation = observationsData.observations.find((obs) => obs._id === observationId);
                                if (foundObservation) {
                                    setObservation(foundObservation);
                                }
                             }
                                else{
                                    const observationsData = await getMyAssignedObservations();
                                    const foundObservation = observationsData.observations.find((obs) => obs._id === observationId);
                                if (foundObservation) {
                                    setObservation(foundObservation);
                                }
                                }


                const usersData = await getUsers();
                console.log("usee",usersData)
                setUsers(usersData);
            } catch (error) {
                            console.error('Error fetching data:', error);
                            toast.error('Failed to load data');
                            if(user.accountType==="Admin"){
                                navigate('/admin/my-actions')
                            }
                            else{
                                navigate('/employee/my-actions');
                            }
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [observationId, navigate]);

    const handleSubmit = async () => {
        if (!observation) return;

        setIsSubmitting(true);
        if (!correctiveAction.trim() || !responsiblePerson || !dateString) {
            toast.error('Please fill in all required fields');
            setIsSubmitting(false);
            return;
        }

        try {
            const updates = {
                correctiveAction: {
                    action: correctiveAction, 
                    responsiblePerson,
                    deadline: dateString,
                }
            };
            
            
            await addCorrectiveAction(observationId, updates);
            toast.success('Observation status updated to In Progress');
            if(user.accountType==="Admin"){
                navigate('/admin/my-actions')
            }
            else{
                navigate('/employee/my-actions');
            }
        } catch (error) {
            console.error('Error updating observation:', error);
            toast.error('Failed to update observation');
        } finally {
            setIsSubmitting(false);
        }
    };

    if (loading) {
        return <div className="flex justify-center items-center h-64">Loading...</div>;
    }

    if (!observation) {
        return <div className="text-center">Observation not found.</div>;
    }

    return (
        <div className="max-w-3xl mx-auto p-4 space-y-8">
            <h1 className="text-3xl font-bold">Waiting for Action</h1>

            <div className="bg-white shadow-md rounded-lg p-6 space-y-4">
                <h2 className="text-xl font-semibold">Observation Details</h2>
                <p>Description: {observation?.description}</p>
                <p>Area: {observation?.area?.name}</p>
                <p>Reported by: {observation?.observedBy?.firstName} {observation?.observedBy?.lastName} ({observation?.observedBy?.email})</p>
                {observation?.photos[0] && (
                    <p>Image: <img src={observation?.photos[0]} height={400} width={400}/> </p>
                )}
            </div>

            <div className="bg-white shadow-md rounded-lg p-6 space-y-4">
                <h2 className="text-xl font-semibold">Add Corrective Action</h2>
                <textarea
                    value={correctiveAction}
                    onChange={(e) => setCorrectiveAction(e.target.value)}
                    placeholder="Enter corrective action..."
                    className="w-full border rounded-md py-2 px-3"
                    required
                />

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <label htmlFor="responsiblePerson" className="block text-sm font-medium text-gray-700">Responsible Person</label>
                        <Select
                            id="responsiblePerson"
                            value={responsiblePerson}
                            onChange={(value) => setResponsiblePerson(value)}
                            className="w-full border rounded-md py-2 px-3"
                            required
                        >
                            <Select.Option value="">Select a person</Select.Option>
                            {users.map(user => (
                                <Select.Option key={user._id} value={user._id}>{user?.firstName} {user?.lastName} </Select.Option>
                            ))}
                        </Select>
                    </div>
                    <div>
                        <label htmlFor="deadline" className="block text-sm font-medium text-gray-700">Deadline</label>
                        
                            <input
                                type="date"
                                id="deadline"
                                className="w-full border rounded-md py-2 px-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                placeholder="Select a date"
                                value={dateString}
                                onChange={(e) =>  setDateString(e.target.value)}
                            />
                       
                    </div>
                </div>
            </div>

            <div className="flex justify-end">
                <button
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                    className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                >
                    {isSubmitting ? 'Submitting...' : 'Submit'}
                </button>
            </div>
            <div className="flex justify-start">
                <button
                    type="button"
                    onClick={() => navigate(-1)}
                    className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-bold py-2 px-4 rounded"

                >
                    Back to List
                </button>
            </div>
        </div>
    );
};

export default WaitingPage;

